import React from 'react';
import {Select, Spin} from "antd";
import useSearch from "../../hooks/useSearch";

function SelectLot({apiEndPoint, onChange, onSelect}) {


	const {loading, results, debouncedSearch, reset} = useSearch(apiEndPoint, 200);

	const handleSearch = async (value) => {
		//console.log(value);
		debouncedSearch(value);
	}

	const handleClear = () => {
		reset();

		if (onSelect)
			onSelect(null);
	}

	const handleSelect = (value) => {
		const selected = results.find(item => item.id === value);
		if (onSelect)
			onSelect(selected);
	}

	// Transformer les résultats pour le format attendu par Select
	const formattedOptions = results
		.filter(item => {
			const type = item.type?.toLowerCase();
			return type === 'maison' || type === 'villa' || type === 'villas';
		})
		.map(item => ({
		value: item.id,
		label: `${item.reference} - ${item.designation} - ${item.type} - ${item.address} (${item.owner})`
	}));

	return (
		<Select
			style={{width: '100%'}}
			allowClear
			showSearch
			onChange={onChange}
			onSelect={handleSelect}
			onClear={handleClear}
			filterOption={false}
			onSearch={handleSearch}
			options={formattedOptions}
			notFoundContent={loading ? <Spin size="small" /> : 'No results found'}
		/>
	);
}

export default SelectLot;